
import React from 'react';
import { Check, X } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const ComparisonSection = () => {
  const { language } = useLanguage();

  const comparisons = language === 'en' ? [
    {
      feature: "Long-term partnership",
      noa: true,
      privateEquity: false,
      strategicBuyer: false
    },
    {
      feature: "Preserve company culture",
      noa: true,
      privateEquity: false,
      strategicBuyer: false
    },
    {
      feature: "No pressure for secondary sale",
      noa: true,
      privateEquity: false,
      strategicBuyer: true
    },
    {
      feature: "Founder involvement options",
      noa: true,
      privateEquity: true,
      strategicBuyer: false
    },
    {
      feature: "Focus on sustainable growth",
      noa: true,
      privateEquity: false,
      strategicBuyer: true
    },
    {
      feature: "Access to operational expertise",
      noa: true,
      privateEquity: true,
      strategicBuyer: true
    }
  ] : [
    {
      feature: "Asociación a largo plazo",
      noa: true,
      privateEquity: false,
      strategicBuyer: false
    },
    {
      feature: "Preservar la cultura de la empresa",
      noa: true,
      privateEquity: false,
      strategicBuyer: false
    },
    {
      feature: "Sin presión para venta secundaria",
      noa: true,
      privateEquity: false,
      strategicBuyer: true
    },
    {
      feature: "Opciones de participación del fundador",
      noa: true,
      privateEquity: true,
      strategicBuyer: false
    },
    {
      feature: "Enfoque en crecimiento sostenible",
      noa: true,
      privateEquity: false,
      strategicBuyer: true
    },
    {
      feature: "Acceso a experiencia operativa",
      noa: true,
      privateEquity: true,
      strategicBuyer: true
    }
  ];

  return (
    <section className="py-20 bg-[#F5F7F9] dark:bg-[#0D1F2D]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="text-center mb-12">
          <h2 className="font-space-grotesk text-3xl font-bold text-[#0D1F2D] dark:text-white mb-4">
            {language === 'en' ? 'The Noa Difference' : 'La Diferencia de Noa'}
          </h2>
          
          <p className="text-[#586F7C] dark:text-[#F6F6F7]/70 text-lg mx-auto max-w-2xl">
            {language === 'en' 
              ? 'See how we compare to traditional exit options' 
              : 'Vea cómo nos comparamos con las opciones de salida tradicionales'}
          </p>
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full min-w-[640px] border-collapse">
            <thead>
              <tr>
                <th className="p-3 text-left text-[#586F7C] dark:text-[#F6F6F7] font-medium">
                  {language === 'en' ? 'Features' : 'Características'}
                </th>
                <th className="p-3 text-center bg-green-500/10 text-[#0D1F2D] dark:text-green-500 font-bold rounded-tl-md">
                  Noa Partners
                </th>
                <th className="p-3 text-center bg-[#EEF0F2] dark:bg-white/5 text-[#586F7C] dark:text-[#F6F6F7]/80 font-medium">
                  {language === 'en' ? 'Private Equity' : 'Capital Privado'}
                </th>
                <th className="p-3 text-center bg-[#EEF0F2] dark:bg-white/5 text-[#586F7C] dark:text-[#F6F6F7]/80 font-medium rounded-tr-md">
                  {language === 'en' ? 'Strategic Buyer' : 'Comprador Estratégico'}
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisons.map((item, index) => (
                <tr key={index} className="border-b border-[#EEF0F2] dark:border-[#2F4550]/30">
                  <td className="p-3 text-[#0D1F2D] dark:text-white font-medium">
                    {item.feature}
                  </td>
                  <td className="p-3 text-center bg-green-500/10">
                    {item.noa ? 
                      <Check className="mx-auto w-5 h-5 text-green-500" /> : 
                      <X className="mx-auto w-5 h-5 text-red-500" />
                    }
                  </td>
                  <td className="p-3 text-center bg-[#EEF0F2] dark:bg-white/5">
                    {item.privateEquity ? 
                      <Check className="mx-auto w-5 h-5 text-green-500" /> : 
                      <X className="mx-auto w-5 h-5 text-red-500" />
                    }
                  </td>
                  <td className="p-3 text-center bg-[#EEF0F2] dark:bg-white/5">
                    {item.strategicBuyer ? 
                      <Check className="mx-auto w-5 h-5 text-green-500" /> : 
                      <X className="mx-auto w-5 h-5 text-red-500" />
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
